import React from "react";
import {
  TextContainer,
  Stack,
  Icon,
  Text,
} from "@shopify/polaris";

import { CircleTickMinor } from "@shopify/polaris-icons";

export default function FeatureItem({ icon, title, description }) {
  return (
    <Stack alignment="leading" wrap={false} spacing="tight">
      {icon ? (
        <Icon color="base" source={icon} />
      ) : (
        <Icon source={CircleTickMinor} color="primary" />
      )}
      <Stack.Item fill>
        <p style={{ marginBottom: "0.25rem" }}>
          <Text>{title}</Text>
        </p>
        {description && (
          <TextContainer spacing="tight">
            <Text color="subdued" variant="bodySm" as="p">{description}</Text>
          </TextContainer>
        )}
      </Stack.Item>
    </Stack>
  );
}
